// Anesthesia & Airway algorithms — v2.1 collaboration prototype.
const da = {
  id: "da",
  specialty: "anestesi",
  available: true,
  title: { id: "Difficult Airway Algorithm", en: "Difficult Airway Algorithm" },
  desc: { id: "", en: "" },
  meta: {
    id: "Sumber: ASA Practice Guidelines for Management of the Difficult Airway 2022 · Direview terakhir: Jul 2026",
    en: "Source: ASA Practice Guidelines for Management of the Difficult Airway 2022 · Last reviewed: Jul 2026",
  },
  blocks: [
    {
      type: "flowTrack",
      steps: [
        {
          badge: "1",
          eyebrow: { id: "Penilaian", en: "Assessment" },
          body: {
            id: "Skrining prediktor sulit intubasi & sulit ventilasi (bag-mask/supraglottic), risiko aspirasi, risiko desaturasi cepat, dan risiko sulit akses jalan napas emergensi.",
            en: "Screen for predictors of difficult intubation & difficult ventilation (bag-mask/supraglottic), aspiration risk, rapid desaturation risk, and difficult emergency airway access.",
          },
        },
        {
          badge: "2",
          decision: true,
          eyebrow: { id: "Keputusan", en: "Decision" },
          body: {
            id: "Pilih strategi: intubasi sadar (awake) atau intubasi setelah induksi anestesi umum?",
            en: "Choose strategy: awake intubation, or intubation after general anaesthesia induction?",
          },
        },
      ],
    },
    {
      type: "branches",
      left: {
        heading: { id: "Pertimbangkan Intubasi Sadar bila...", en: "Consider Awake Intubation when..." },
        color: "primary",
        steps: [
          {
            badge: "3a",
            body: { id: "", en: "" },
            list: {
              id: [
                "Sulit ventilasi diantisipasi",
                "Risiko aspirasi meningkat",
                "Tidak toleran periode apnea singkat",
                "Diperkirakan sulit akses airway emergensi/invasif",
              ],
              en: [
                "Anticipated difficult ventilation",
                "Increased aspiration risk",
                "Cannot tolerate brief apnoea",
                "Predicted difficult emergency/invasive airway access",
              ],
            },
          },
        ],
      },
      right: {
        heading: { id: "Intubasi Setelah Induksi (risiko rendah)", en: "Intubation After Induction (low risk)" },
        color: "slate",
        steps: [
          {
            badge: "3b",
            body: {
              id: "Bila ventilasi adekuat tapi intubasi gagal: batasi percobaan, kombinasi teknik (video-laringoskopi + bronkoskopi fleksibel), atau bangunkan pasien bila non-emergensi.",
              en: "If ventilation is adequate but intubation fails: limit attempts, combine techniques (video-laryngoscopy + flexible bronchoscopy), or wake the patient if non-emergent.",
            },
          },
        ],
      },
    },
    {
      type: "panel",
      heading: { id: "Prinsip Sepanjang Proses", en: "Principles Throughout" },
      tags: [
        { id: "Optimalkan oksigenasi", en: "Optimise oxygenation" },
        { id: "Batasi jumlah percobaan laringoskopi", en: "Limit laryngoscopy attempts" },
        { id: "Panggil bantuan lebih awal", en: "Call for help early" },
        { id: "Konfirmasi tube dengan kapnografi", en: "Confirm tube with capnography" },
      ],
    },
    {
      type: "flowTrack",
      steps: [
        {
          badge: "4",
          decision: true,
          eyebrow: { id: "Keputusan Kritis", en: "Critical Decision" },
          body: { id: "Bisa ventilasi?", en: "Can you ventilate?" },
          bodyExtra: {
            id: "Ya, ventilasi adekuat tapi intubasi gagal → lanjutkan usaha terbatas/teknik alternatif, atau tunda & bangunkan pasien bila memungkinkan.",
            en: "Yes, ventilation adequate but intubation failed → continue limited attempts/alternative techniques, or postpone & wake the patient if possible.",
          },
          danger: {
            id: "Tidak — CICO (Can't Ventilate, Can't Oxygenate) → segera airway invasif (krikotiroidotomi/front-of-neck access), jangan menunda.",
            en: "No — CICO (Can't Ventilate, Can't Oxygenate) → immediate invasive airway (cricothyroidotomy/front-of-neck access), do not delay.",
          },
        },
      ],
    },
    {
      type: "disclaimer",
      text: {
        id: "Prinsip kunci: kegagalan sebenarnya bukan saat harus melakukan airway invasif — kegagalan adalah terlambat melakukannya. Bukan pengganti pelatihan airway management.",
        en: "Key principle: the true failure is not needing an invasive airway — it is being late in performing it. Not a substitute for airway-management training.",
      },
    },
  ],
};

const rsi = {
  id: "rsi",
  specialty: "anestesi",
  available: true,
  title: { id: "Rapid Sequence Intubation (RSI)", en: "Rapid Sequence Intubation (RSI)" },
  desc: { id: "", en: "" },
  meta: {
    id: "Sumber: kerangka umum praktik anestesi/emergensi · Direview terakhir: Jul 2026",
    en: "Source: general framework of anaesthesia/emergency practice · Last reviewed: Jul 2026",
  },
  blocks: [
    {
      type: "flowTrack",
      steps: [
        {
          badge: "1",
          eyebrow: { id: "7P", en: "7 P's" },
          body: { id: "Preparasi alat & obat.", en: "Preparation of equipment & drugs." },
        },
        { badge: "2", body: { id: "Preoksigenasi (100% O2 3–5 menit atau 8x napas dalam).", en: "Preoxygenation (100% O₂ for 3–5 min or 8 deep breaths)." } },
        { badge: "3", body: { id: "Pretreatment bila ada indikasi khusus.", en: "Pretreatment when specific indications apply." } },
        { badge: "4", body: { id: "Paralisis + induksi diberikan bersamaan.", en: "Paralysis + induction given simultaneously." } },
        { badge: "5", body: { id: "Posisi optimal untuk laringoskopi.", en: "Optimal position for laryngoscopy." } },
        {
          badge: "6",
          body: {
            id: "Konfirmasi penempatan tube — wajib kapnografi, bukan hanya auskultasi.",
            en: "Confirm tube placement — capnography mandatory, not auscultation alone.",
          },
        },
        { badge: "7", body: { id: "Perawatan pasca-intubasi.", en: "Post-intubation care." } },
      ],
    },
    {
      type: "panel",
      heading: { id: "Pilihan Obat (dosis lengkap di menu Drug & Fluid)", en: "Drug Choices (full doses in Drug & Fluid menu)" },
      table: {
        headers: { id: ["Kategori", "Pilihan"], en: ["Category", "Choice"] },
        rows: [
          [
            { id: "Induksi — stabil", en: "Induction — stable" },
            { id: "Propofol", en: "Propofol" },
          ],
          [
            { id: "Induksi — risiko hipotensi/syok", en: "Induction — hypotension/shock risk" },
            { id: "Etomidate atau ketamin", en: "Etomidate or ketamine" },
          ],
          [
            { id: "Pelumpuh otot", en: "Neuromuscular blocker" },
            { id: "Suksinilkolin atau rocuronium", en: "Succinylcholine or rocuronium" },
          ],
        ],
      },
    },
    {
      type: "panel",
      heading: { id: "Bila Gagal Intubasi", en: "If Intubation Fails" },
      paragraph: {
        id: "Masuk ke Difficult Airway Algorithm.",
        en: "Enter the Difficult Airway Algorithm.",
      },
    },
    {
      type: "disclaimer",
      text: {
        id: "Dosis spesifik disesuaikan kondisi klinis pasien (hemodinamik, komorbid) dan protokol RS setempat.",
        en: "Specific doses depend on patient condition (haemodynamics, comorbidities) and local hospital protocol.",
      },
    },
  ],
};

const last = {
  id: "last",
  specialty: "anestesi",
  available: false,
  title: { id: "Local Anesthetic Systemic Toxicity (LAST)", en: "Local Anesthetic Systemic Toxicity (LAST)" },
  desc: { id: "", en: "" },
  meta: {
    id: "Sumber: ASRA Checklist for Treatment of LAST 2020 (direview ulang 2025) · Direview terakhir: Jul 2026",
    en: "Source: ASRA Checklist for Treatment of LAST 2020 (re-reviewed 2025) · Last reviewed: Jul 2026",
  },
  blocks: [
    {
      type: "panel",
      heading: { id: "Kenali Tanda Dini", en: "Recognise Early Signs" },
      tags: [
        { id: "Perubahan status mental mendadak", en: "Sudden altered mental status" },
        { id: "Agitasi", en: "Agitation" },
        { id: "Tinnitus", en: "Tinnitus" },
        { id: "Baal perioral", en: "Perioral numbness" },
        { id: "Kejang", en: "Seizure" },
      ],
      footnote: {
        id: "Dapat diikuti aritmia, bradikardia, hingga henti jantung. Onset bisa segera atau tertunda beberapa jam.",
        en: "May be followed by arrhythmia, bradycardia, up to cardiac arrest. Onset may be immediate or delayed by hours.",
      },
    },
    {
      type: "flowTrack",
      steps: [
        {
          badge: "1",
          eyebrow: { id: "Aksi Awal", en: "Initial Action" },
          body: {
            id: "Hentikan injeksi anestesi lokal, minta bantuan, O2 100%, kelola jalan napas.",
            en: "Stop the local anaesthetic injection, call for help, 100% O₂, manage the airway.",
          },
        },
        {
          badge: "2",
          body: {
            id: "Kejang → benzodiazepin. Hindari propofol dosis besar bila hemodinamik tidak stabil.",
            en: "Seizure → benzodiazepine. Avoid large-dose propofol if haemodynamically unstable.",
          },
        },
        {
          badge: "3",
          decision: true,
          eyebrow: { id: "Keputusan", en: "Decision" },
          body: {
            id: "Ada instabilitas kardiovaskular / aritmia / henti jantung?",
            en: "Cardiovascular instability / arrhythmia / cardiac arrest?",
          },
          bodyExtra: {
            id: "Tidak, gejala neuro ringan → observasi ketat, emulsi lipid tetap dipertimbangkan. Ya → lanjut di bawah.",
            en: "No, mild neuro symptoms → close observation, lipid emulsion still considered. Yes → continue below.",
          },
        },
      ],
    },
    {
      type: "panel",
      heading: { id: "Emulsi Lipid 20% (Lipid Rescue)", en: "20% Lipid Emulsion (Lipid Rescue)" },
      table: {
        headers: { id: ["Berat Badan", "Dosis"], en: ["Body weight", "Dose"] },
        rows: [
          [
            { id: "< 70 kg", en: "< 70 kg" },
            {
              id: "Bolus 1.5 mL/kg (2–3 menit), lanjut infus 0.25 mL/kg/menit",
              en: "Bolus 1.5 mL/kg over 2–3 min, then infusion 0.25 mL/kg/min",
            },
          ],
          [
            { id: "≥ 70 kg", en: "≥ 70 kg" },
            { id: "Bolus 100 mL, lanjut infus sesuai checklist ASRA", en: "Bolus 100 mL, then infusion per the ASRA checklist" },
          ],
        ],
        footnote: {
          id: "Bila instabilitas menetap: ulangi bolus 1–2x, dapat menggandakan kecepatan infus. Lanjutkan ≥15 menit setelah stabil. Batas atas total ~12 mL/kg.",
          en: "If instability persists: repeat bolus 1–2×, may double the infusion rate. Continue ≥15 min after stabilisation. Upper limit ~12 mL/kg total.",
        },
      },
    },
    {
      type: "panel",
      heading: { id: "Modifikasi ACLS untuk Henti Jantung akibat LAST", en: "ACLS Modifications for LAST Cardiac Arrest" },
      tags: [
        { id: "Epinefrin dosis kecil (≤1 mcg/kg)", en: "Low-dose epinephrine (≤1 mcg/kg)" },
        { id: "Hindari vasopressin", en: "Avoid vasopressin" },
        { id: "Hindari calcium channel blocker", en: "Avoid calcium channel blockers" },
        { id: "Hindari beta-blocker", en: "Avoid beta-blockers" },
        { id: "Hindari anestesi lokal lain", en: "Avoid other local anaesthetics" },
      ],
    },
    {
      type: "panel",
      heading: { id: "Bila ACLS + Lipid Gagal", en: "If ACLS + Lipid Fail" },
      paragraph: {
        id: "Pertimbangkan cardiopulmonary bypass (CPB)/ECMO — hubungi fasilitas terdekat lebih awal. Observasi pasca-stabilisasi diperpanjang (risiko rekurensi tertunda).",
        en: "Consider cardiopulmonary bypass (CPB)/ECMO — contact the nearest facility early. Extended post-stabilisation observation (delayed recurrence risk).",
      },
    },
    {
      type: "disclaimer",
      text: {
        id: "Pastikan kit LAST (emulsi lipid 20% + checklist) tersedia di tiap lokasi tindakan blok regional/anestesi lokal dosis besar.",
        en: "Ensure a LAST kit (20% lipid emulsion + checklist) is available at every site performing regional blocks / high-dose local anaesthesia.",
      },
    },
  ],
};

const mh = {
  id: "mh",
  specialty: "anestesi",
  available: false,
  title: { id: "Malignant Hyperthermia (MH)", en: "Malignant Hyperthermia (MH)" },
  desc: { id: "", en: "" },
  meta: {
    id: "Sumber: kerangka umum standar internasional (MHAUS / konsensus JSA 2025) · Direview terakhir: Jul 2026",
    en: "Source: international standard framework (MHAUS / JSA 2025 consensus) · Last reviewed: Jul 2026",
  },
  blocks: [
    {
      type: "panel",
      heading: { id: "Kenali Tanda Dini", en: "Recognise Early Signs" },
      tags: [
        { id: "EtCO2 naik mendadak", en: "Sudden EtCO₂ rise" },
        { id: "Takikardia tak terjelaskan", en: "Unexplained tachycardia" },
        { id: "Rigiditas otot (masseter)", en: "Muscle rigidity (masseter)" },
        { id: "Suhu naik cepat (tanda lanjut)", en: "Rapid temperature rise (late sign)" },
      ],
    },
    {
      type: "flowTrack",
      steps: [
        {
          badge: "1",
          eyebrow: { id: "Aksi Awal", en: "Initial Action" },
          body: { id: "", en: "" },
          list: {
            id: [
              "Hentikan semua agen pencetus (volatil, suksinilkolin)",
              "Ganti ke TIVA propofol",
              "Hiperventilasi O2 100% aliran tinggi",
              "Minta bantuan tambahan — ini kegawatan tim",
            ],
            en: [
              "Stop all triggering agents (volatiles, succinylcholine)",
              "Switch to TIVA propofol",
              "Hyperventilate with 100% O₂ high-flow",
              "Call for additional help — this is a team emergency",
            ],
          },
        },
        {
          badge: "2",
          eyebrow: { id: "Terapi Definitif", en: "Definitive Therapy" },
          body: {
            id: "Dantrolene IV 2.5 mg/kg bolus cepat, ulangi tiap 5 menit sesuai respons hingga dosis kumulatif 10 mg/kg atau lebih pada kasus berat.",
            en: "Dantrolene IV 2.5 mg/kg rapid bolus, repeat every 5 min per response up to a cumulative dose of 10 mg/kg or more in severe cases.",
          },
        },
        {
          badge: "3",
          body: {
            id: "Pendinginan aktif (cairan IV dingin, kompres es axilla/groin/leher) — hentikan bila suhu mendekati normal (cegah hipotermia rebound).",
            en: "Active cooling (cold IV fluids, ice packs to axilla/groin/neck) — stop as temperature approaches normal (prevent rebound hypothermia).",
          },
        },
      ],
    },
    {
      type: "panel",
      heading: { id: "Komplikasi Paralel", en: "Parallel Complications" },
      tags: [
        {
          id: "Hiperkalemia → kalsium, insulin-glukosa, bikarbonat",
          en: "Hyperkalaemia → calcium, insulin-glucose, bicarbonate",
        },
        { id: "Aritmia → hindari calcium channel blocker", en: "Arrhythmia → avoid calcium channel blockers" },
        { id: "Monitor mioglobinuria/gagal ginjal", en: "Monitor myoglobinuria/renal failure" },
      ],
    },
    {
      type: "panel",
      heading: { id: "Pasca-Stabilisasi", en: "Post-Stabilisation" },
      paragraph: {
        id: "ICU minimal 24 jam (risiko rekrudesensi), CK serial, konseling keluarga untuk skrining kerentanan MH.",
        en: "ICU for at least 24 h (recrudescence risk), serial CK, family counselling for MH-susceptibility screening.",
      },
    },
    {
      type: "disclaimer",
      text: {
        id: "Pastikan ketersediaan stok dantrolene & jalur konsultasi/hotline MH sesuai sumber daya lokal.",
        en: "Ensure dantrolene stock & MH consultation/hotline access per local resources.",
      },
    },
  ],
};

export const ANESTESI_ALGOS = { da, rsi, last, mh };
